import classNames from 'classnames';
import useCustomDropzone from 'hooks/useCustomDropzone';
import type { FC } from 'react';
import { useState } from 'react';
import type { DropzoneProps } from './Dropzone.types';
import { DropzoneState } from 'react-dropzone';

export const DropzoneControlled: FC<
  Omit<DropzoneProps, 'dropOptions'> & {
    dropzoneAPI: DropzoneState;
    disabled?: boolean;
  }
> = ({
  dropzoneAPI,
  render,
  className,
  disabled,
  renderWrapperClassName,
  onClick,
}) => {
  const { getRootProps, getInputProps, ...meta } = dropzoneAPI;

  const [isHovered, setIsHovered] = useState(false);

  const dropzoneMeta = {
    ...meta,
    isHovered,
  };

  const rootProps = getRootProps({
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
  });

  return (
    <div
      {...rootProps}
      className={classNames(
        className,
        'rounded-lg border border-primary-100 overflow-hidden',
        {
          'cursor-not-allowed !opacity-50': disabled,
          'cursor-pointer': !disabled,
        },
      )}
      onClick={onClick ? onClick : (rootProps as any).onClick}
    >
      <input {...getInputProps()} />

      <div
        className={classNames(
          'h-full flex flex-col justify-center items-center p-8',
          renderWrapperClassName,
        )}
      >
        {render(dropzoneMeta)}
      </div>
    </div>
  );
};

const Dropzone: FC<DropzoneProps> = (props) => {
  const dropzoneAPI = useCustomDropzone(props.dropOptions);

  return (
    <DropzoneControlled
      {...props}
      disabled={props.dropOptions?.disabled}
      dropzoneAPI={dropzoneAPI}
    />
  );
};

export default Dropzone;
